// Update the last item of the main menu
function updateMainMenuStyle() {
  const menu_last_item = document.getElementById(`HeaderMenu-sale`);
  if (menu_last_item) {
    menu_last_item.classList.add('header__menu-item-last');
  }
  const menu_last_sub = document.getElementById(`HeaderMenu-MenuList-12`);
  if (menu_last_sub) {
    menu_last_sub.classList.add('header__submenu-last');
  }
  
}

// Format prices with smaller decimals
function formatPriceDecimals() {
  const priceElements = document.querySelectorAll('.price-item');
  priceElements.forEach((element) => {
    
    var _price = element.textContent;
    var split = _price.split('.');

    if (split.length >= 2){
        var half = split[1].replace(/(\d\d)/, `<span class="price__custom_decimal">$1</span>`);
        var price = `${split[0]}${half}`;
        element.innerHTML = price.trim();
    }
  });
}

// Call the function when the page loads
document.addEventListener('DOMContentLoaded', () => {
  formatPriceDecimals();
  //setTimeout(formatPriceDecimals, 2000);
  updateMainMenuStyle();
});

window.addEventListener('load', () => {
  formatPriceDecimals();
  updateMainMenuStyle();
});

// Function to handle AJAX start event
function handleAjaxStart() {
  //console.log('An AJAX request has started.');
}

// Function to handle AJAX stop event
function handleAjaxStop() {
  //console.log('All AJAX requests have completed.');
}

// Function to add event listeners for AJAX events
function addAjaxEventListeners() {
  // Intercept AJAX requests by overriding the XMLHttpRequest.open method
  const originalOpen = XMLHttpRequest.prototype.open;

  XMLHttpRequest.prototype.open = function(method, url) {
    this.addEventListener('loadstart', () => {
      handleAjaxStart();
    });

    this.addEventListener('loadend', () => {
      handleAjaxStop();
    });

    originalOpen.apply(this, arguments);
  }
}

// Call addAjaxEventListeners to add event listeners for AJAX events
//addAjaxEventListeners();


// Function to handle changes in the HTML content
function handleContentChange(mutationsList, observer) {
  mutationsList.forEach((mutation) => {
    if (mutation.type === 'childList') {
      // HTML content has changed (child elements added or removed)
      //console.log('HTML content has changed.');
      formatPriceDecimals();
    }
  });
}

// Create a Mutation Observer
const observer = new MutationObserver(handleContentChange);

// Define the target element to observe (e.g., the <body> element)
const targetNode = document.body;

// Configure the observer to watch for changes in child elements
const observerConfig = { childList: true, subtree: true };

// Start observing the target element
observer.observe(targetNode, observerConfig);